import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=02cbcd5d&"
var script = {}
import style0 from "./layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports